<template>

	<video 
	:style="data.style"
	class="window-video"
	autoplay loop playsinline muted
	@click="playJoke($event)">
		<source :src="data.src" type="video/mp4">
	</video>
	
</template>

<script>

	export default {

		props: ['data'],

		mounted () {
			var promise = document.querySelector('video').play()

			if (promise !== undefined) {
				promise.then(_ => {
				}).catch(error => {
					if (!(error instanceof Error)) {
    					error = new Error(error);
  					}
  					console.error(error.message);
				});
			}
		},

 		methods: {

 			playJoke(video) {

 				video.target.play()

 			}

 		}

 	}

 </script>

<style scoped>
 	
 .window-video {

 	position: absolute;
 	z-index: 10;

 }

 </style>


// WEBPACK FOOTER //
// WindowVideo.vue?bf2faa5e